<template>
    <CChartPie :datasets="defaultDatasets" :labels="labelPayment" />
</template>

<script>
import { CChartPie } from '@coreui/vue-chartjs';
import { mapActions } from "vuex";

export default {
    name: 'CChartPieExample',
    components: { CChartPie },
    data() {
        return {
            prefix: "beads",
            metodsPayments: [],
            ingresosMensuales: [],
            datosMensuales: [],
            verificBead: false,
            bead: {
                id: ""
            }
        }
    },
    created() {
        this.getData();
    },
    computed: {
        defaultDatasets() {
            return [
                {
                    backgroundColor: [
                        '#41B883',
                        '#0a4d86',
                        '#DD4B18',
                        '#e5e5e5',
                        '#8527a4',
                        '#08e1ca',
                        '#DD4B18',
                    ],
                    data: this.getMonthlyIncomeValues()
                }
            ]
        },
        labelPayment() {
            return this.metodsPayments.map(mp => mp.name);
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        getData: function () {
            this.get({
                url: this.$store.getters.get__url + "/beads/indexHome/" + this.$store.getters.get_campu.id + "/" + this.$store.getters.get_company.id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode == 200) {
                    // console.log(response.data);
                    this.metodsPayments = response.data.methodPayment;
                    this.datosMensuales = response.data.monthlyIncome;
                }
            });
        },
        getMonthlyIncomeValues() {
            return this.metodsPayments.map(method => {
                const income = this.datosMensuales.find(d => d.method_payment_id === method.id);
                return income ? parseFloat(income.total) : 0;
            });
        }
    }
}
</script>